import { SubstrateContentDomainTypes } from '@office-start/document-types';
import { getReferral } from '@office-start/telemetry-utility';
import { logFeature } from './logFeature';
import { logUserAction } from './logUserAction';
export function logReferUserAction(actionId, area, referral, subArea, actionType, eventName, isScdType) {
    var _a;
    if (isScdType === void 0) { isScdType = false; }
    var safeReferral = referral ? getReferral(referral, isScdType) : '';
    logUserAction({
        id: actionId,
        area: area,
        subArea: subArea ? subArea : 'Other',
        result: referral ? 'Refer' : 'Navigate',
        target: safeReferral || 'Other',
        type: actionType ? actionType : 'Click',
        targetId: safeReferral,
        eventName: eventName ? eventName : '',
    });
    if (isScdType) {
        var params = (_a = {},
            _a['ConnectionType'] = referral ? inScdType(referral) || '' : '',
            _a);
        logFeature({
            featureName: "SubstrateContentDomain" /* KnownFeatureNames.SubstrateContentDomain */,
            eventName: 'SCDItemClicks',
            params: params,
        });
    }
}
export function inScdType(scdType) {
    var inScdType = Object.values(SubstrateContentDomainTypes).find(function (x) { return x === scdType; });
    return inScdType;
}
//# sourceMappingURL=logReferUserAction.js.map